var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ev-signup" }, [
    _c("h4", [
      _vm._v("Redirecting to " + _vm._s(this.getLoginURL()) + "/signup ... ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }